import ModalCompanyCreate from './ModalCompanyCreate';
import ModalCompanyDelete from './ModalCompanyDelete';
import ModalCompanyFilter from './ModalCompanyFilter';
import ModalCompanyUpdate from './ModalCompanyUpdate';

export default Object.assign(
  {},
  {
    Create: ModalCompanyCreate,
    Update: ModalCompanyUpdate,
    Filter: ModalCompanyFilter,
    Delete: ModalCompanyDelete,
  },
);
